import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import classNames from 'classnames';
import { Icons, Row } from '../../../../components/base/BootstrapComponents/BootstrapComponents';
import FieldDTOWithCol from '../../../../components/fields/Abstract/FieldDTOWithCol';
import TextInputWithLabel from '../../../../components/fields/TextInput/TextInputWithLabel';
import CustomSelectInput from '../../../../components/fields/SelectInput/CustomSelectInput';
import FileInput from '../../../../components/fields/FileInput/FileInput';
import ApplicationsDTO from '../../../../dto/ApplicationsDTO';
import {
  APPLY_METHOD_TYPE_LIST,
  DELIVERY_METHOD_EXTRACTS_TYPE_LIST,
  DELIVERY_METHOD_TYPE_LIST,
  DOCUMENT_SUBMISSION_TYPE_LIST,
  NOTIFICATION_METHOD_TYPE_LIST,
  PROCEDURE_TYPE,
  PROCEDURE_TYPE_LIST,
} from '../../../../configs';
import { responseLogWithNotification } from '../../../../utils/utils';
import DateTimePicker from '../../../../components/fields/DatePicker/DateTimePicker';
import DatePicker from '../../../../components/fields/DatePicker/DatePicker';
import { registerMaisEgu } from '../../actions';

export default function ApplicationInfo(props) {
  const {
    control, formMeta, procedure, isEdit, getValues = () => {}, setValue = () => {}, title, isPreview = false,
  } = props;
  const dto = new ApplicationsDTO();
  const attributes = dto.getAttributesByName();
  const dispatch = useDispatch();
  const [locked, setLocked] = useState(false);

  const handleRegisterMaisEgu = () => {
    const values = getValues();
    if (values?.mais_egu_id) {
      return null;
    }
    setLocked(true);
    dispatch(registerMaisEgu(values)).then(data => {
      setValue('mais_egu_id', data?.applicationId || '');
      setLocked(false);
    }).catch(e => { setLocked(false); responseLogWithNotification(e); });
  };

  function PreviewFileInputs() {
    return (
      <>
        <Row className="row-cols-3">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={CustomSelectInput}
            dtoObject={{
              ...attributes.procedure,
              labelKey: 'procedure.name',
            }}
            variant="material"
            withLabel
            options={PROCEDURE_TYPE_LIST}
            disabled
          />
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={TextInputWithLabel}
            dtoObject={procedure !== PROCEDURE_TYPE.PROCEDURE_kt_exlt
              ? attributes.mais_egu_id
              : {
                ...attributes.mais_egu_id,
                labelKey: 'mais_egu_id_alternative',
              }}
            variant="material"
            withLabel
          />
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={DateTimePicker}
            hideTime
            changeFormat="YYYY-MM-DD"
            dtoObject={attributes.applied_at}
            variant="material"
            withLabel
            disabled={isEdit}
          />
        </Row>
        <Row className="row-cols-2">
          <FieldDTOWithCol
            control={control}
            type="text"
            hideTime
            component={DateTimePicker}
            changeFormat="YYYY-MM-DD"
            dtoObject={attributes.review_date}
            variant="material"
            withLabel
            disabled={isEdit}
          />
          <FieldDTOWithCol
            control={control}
            type="text"
            hideTime
            component={DateTimePicker}
            changeFormat="YYYY-MM-DD"
            dtoObject={attributes.consider_apply_date}
            variant="material"
            withLabel
            disabled={isEdit}
          />
        </Row>
        <Row className="row-cols-2">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={FileInput}
            dtoObject={attributes.apply_files}
            namePrefix="media."
            variant="material"
            multiple
          />
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={FileInput}
            dtoObject={attributes.list_of_documents}
            variant="material"
            namePrefix="media."
            multiple
          />
        </Row>
      </>
    );
  }

  function NonPreviewBlocks() {
    return (
      <>
        <Row className="row-cols-3">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={CustomSelectInput}
            dtoObject={{
              ...attributes.procedure,
              labelKey: 'procedure.name',
            }}
            variant="material"
            withLabel
            options={PROCEDURE_TYPE_LIST}
            disabled
          />
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={TextInputWithLabel}
            dtoObject={procedure !== PROCEDURE_TYPE.PROCEDURE_kt_exlt
              ? attributes.mais_egu_id
              : {
                ...attributes.mais_egu_id,
                labelKey: 'mais_egu_id_alternative',
              }}
            variant="material"
            withLabel
          />
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={DateTimePicker}
            hideTime
            changeFormat="YYYY-MM-DD"
            dtoObject={attributes.applied_at}
            variant="material"
            withLabel
            disabled={isEdit}
          />
        </Row>
        <Row className="row-cols-3">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={DateTimePicker}
            hideTime
            changeFormat="YYYY-MM-DD"
            dtoObject={attributes.created_at}
            variant="material"
            withLabel
            disabled
          />
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={DatePicker}
            hideTime
            changeFormat="YYYY-MM-DD"
            dtoObject={attributes.updated_at}
            variant="material"
            withLabel
            disabled
          />
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={DatePicker}
            hideTime
            changeFormat="YYYY-MM-DD"
            dtoObject={attributes.processing_time_limits}
            variant="material"
            withLabel
            disabled
          />
        </Row>
        <Row className="row-cols-3">
          <FieldDTOWithCol
            control={control}
            type="text"
            hideTime
            component={DateTimePicker}
            changeFormat="YYYY-MM-DD"
            dtoObject={attributes.decision_deadline_date}
            variant="material"
            withLabel
            disabled={isEdit}
          />
          <FieldDTOWithCol
            control={control}
            type="text"
            changeFormat="YYYY-MM-DD"
            hideTime
            dtoObject={attributes.review_date}
            component={DateTimePicker}
            variant="material"
            withLabel
            disabled={isEdit}
          />
          <FieldDTOWithCol
            control={control}
            type="text"
            changeFormat="YYYY-MM-DD"
            hideTime
            dtoObject={attributes.consider_apply_date}
            component={DateTimePicker}
            variant="material"
            withLabel
            disabled={isEdit}
          />
        </Row>
        <Row className="row-cols-3">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={CustomSelectInput}
            dtoObject={attributes.apply_method}
            variant="material"
            options={APPLY_METHOD_TYPE_LIST}
            withLabel
          />
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={FileInput}
            dtoObject={attributes.apply_files}
            namePrefix="media."
            variant="material"
            multiple
          />
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={CustomSelectInput}
            dtoObject={attributes.document_submission_type}
            variant="material"
            withLabel
            options={DOCUMENT_SUBMISSION_TYPE_LIST}
          />
        </Row>
        <Row className="row-cols-3">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.procedure_conducting_authority}
            variant="material"
          />
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={CustomSelectInput}
            dtoObject={attributes.delivery_method_extracts_from_register}
            variant="material"
            options={DELIVERY_METHOD_EXTRACTS_TYPE_LIST}
            withLabel
          />
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={CustomSelectInput}
            dtoObject={attributes.delivery_method_notification}
            variant="material"
            withLabel
            options={DELIVERY_METHOD_TYPE_LIST}
          />
        </Row>
        <Row className="row-cols-2">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={CustomSelectInput}
            dtoObject={attributes.notification_method}
            variant="material"
            withLabel
            options={NOTIFICATION_METHOD_TYPE_LIST}
          />
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={FileInput}
            dtoObject={attributes.list_of_documents}
            variant="material"
            namePrefix="media."
            multiple
          />
        </Row>
      </>
    );
  }

  return (
    <>
      {title && <div className="f4">Информация об обращении</div>}
      {!isPreview ? <NonPreviewBlocks /> : <PreviewFileInputs />}
    </>
  );
}
